/* -------------------------------------------------------------------------- */
/*                               Schema JobsBacklog                             */
/* -------------------------------------------------------------------------- */

import { schema } from 'normalizr';

export const user = new schema.Entity('users', {}, { idAttribute: 'userId' });
export const users = new schema.Array(user);
